// extracted by mini-css-extract-plugin
export var modal = "_gn-0";